export const Types = {
  setGlobalLoading: 'fullpageLoader/SET_GLOBAL_LOADING'
}

export function setGlobalLoading (isLoading) {
  return {
    type: 'fullpageLoader/SET_GLOBAL_LOADING',
    payload: { isLoading }
  }
}
